import { COLORS } from '@/constants'
import { FC } from 'react'

type BookmarkIconProps = {
  width?: number;
  height?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const BookmarkIcon: FC<BookmarkIconProps> = ({
  width = 26,
  height = 26,
  isActive,
  ...rest
}) => <svg width={width} height={height} {...rest} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.3335 14.984V8.0896C3.3335 5.06179 3.3335 3.54789 4.3098 2.60727C5.28612 1.66666 6.85746 1.66666 10.0002 1.66666C13.1428 1.66666 14.7142 1.66666 15.6905 2.60727C16.6668 3.54789 16.6668 5.06179 16.6668 8.0896V14.984C16.6668 16.9056 16.6668 17.8663 16.0228 18.2102C14.7756 18.8762 12.4362 16.6543 11.3252 15.9853C10.6808 15.5973 10.3587 15.4033 10.0002 15.4033C9.64166 15.4033 9.3195 15.5973 8.67516 15.9853C7.56416 16.6543 5.22472 18.8762 3.97754 18.2102C3.3335 17.8663 3.3335 16.9056 3.3335 14.984Z" stroke={isActive ? COLORS['secondary/500'] : COLORS['primary/500']} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.3335 5.83334H16.6668" stroke={isActive ? COLORS['secondary/500'] : COLORS['primary/500']} strokeWidth="1.5" />
  </svg>